import styles from './Customer.module.scss';

interface Props {
    author?: string;
    company?: string;
    companyUrl?: string;
}

export function Customer({ author, company, companyUrl }: Props) {
    if (!author && !company) {
        return null;
    }

    return (
        <div className={styles.text}>
            {author && <span className={styles.author}>{author}</span>}

            {author && company && <>,&nbsp;</>}

            {company && (
                <span className={styles.company}>
                    {companyUrl ? (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={companyUrl}
                            className={styles.companyLink}
                        >
                            {company}
                        </a>
                    ) : (
                        company
                    )}
                </span>
            )}
        </div>
    );
}
